module.exports = __webpack_public_path__ + "img/toprule_left01.11a61bc1.png";